import * as React from "react"
import { Typography } from "@mui/material"
import { BasicTableSeeker } from "@ui-seeker/core"

import { BORDER_COLOR, BORDER_STYLE } from "@constants"
import { actionsColumn, dateColumn } from "./columns"


export default function HistoricalTable ({ data, ...props }) {

    const NoDataMessage = () => <Typography align="center">
        The necessary conditions for this alert have not been satisfied.
    </Typography>
    
    if (!data.length) return <NoDataMessage />

    return <BasicTableSeeker
        data={data}
        headers={[[
            { 
                label: 'Date', 
                sx: { borderLeft: BORDER_STYLE, borderColor: BORDER_COLOR, fontWeight: 'bold', backgroundColor: "primary.lighter" } 
            },
            { 
                label: 'Actions',
                sx: { width: 400, borderLeft: BORDER_STYLE, borderColor: BORDER_COLOR, fontWeight: 'bold', backgroundColor: "primary.lighter" } 
            }
        ]]}
        columns={[
            dateColumn(),
            actionsColumn()
        ]}
        cardProps={{ sx: { boxShadow: 0 } }}
        sx={{ overflowX: 'hidden', width: 800 }}
        {...props}
    />
}